<template>
  <div class='notifications-settings'>
     <span class='back-to-notifications' @click='toggleNotificationsSettingsWindow'>
        <span class="material-icons">
            arrow_back
        </span>
       <span class='back-to-notification-btn-text'>
        {{ $t('notifications.setting.go.back.to.notifications.btn') }}
       </span>
     </span>
    <div class='coming-soon-wrapper'>
      <coming-soon/>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ComingSoon from '@/components/common/ComingSoon.vue';

export default {
  name: 'NotificationsSettings',
  components: {
    ComingSoon,
  },
  computed: {
    ...mapGetters(['notifications']),
  },
  methods: {
    toggleNotificationsSettingsWindow() {
      this.$emit('toggleNotificationsSettingsWindow');
    },
  },
};
</script>

<style lang='scss' scoped>
@import '~@/assets/styles/design-system';

.notifications-settings {
  width: 100%;
  height: 100%;
  padding-left: $space-5;
  padding-top: $space-4;
  .back-to-notifications {
    margin-right: 43%;
    .back-to-notification-btn-text {
      height: $space-4;
      width: fit-content;
      color: var(--btn-primary-bg);
      font-family: $font-family-medium;
      font-size: $font-size-sm;
      font-weight: 500;
      letter-spacing: rem(1.1);
      line-height: $space-4;
      text-align: center;
    }
    .material-icons {
      margin-right: $space-4;
      display: table-caption;
      height: $space-4;
      width: $space-4;
      color: var(--btn-primary-bg);
    }
    &:hover {
      cursor: pointer;
    }
  }
  .coming-soon-wrapper {
    margin-top: 90%;
    margin-right: $space-5;
    font-size: $font-size-4xl;
    .coming-soon {
      display: inline-block;
      color: $coming-soon;
      text-align: center;
      border: solid $border-width-thin $coming-soon;
      padding: $space-4;
      border-radius: rem(5);
    }
  }
}
</style>
